import styled from 'styled-components';
import { makeContainer } from 'src/lib/mixins';
import { rem } from 'lib/units';

export const Container = styled.section`
    ${makeContainer};
    text-align: center;
    padding: ${rem(100)} 0;
`;